import ProductFilter from '../lib/robust/ProductFilter';

window.robust = window.robust || {};
window.robust.productFilter = new ProductFilter();